/**
 * Who typed a proposal that arrived somewhere else.
 *
 * ITS OWN FILE because two screens read it — the writing card and the docket row — and the second
 * of those is where most of the league actually reads a proposal. It lived inside `Proposals.tsx`
 * and importing it from `Docket.tsx` made the two files import each other, which works in ESM
 * right up to the first time somebody moves a top-level constant.
 */

import { managerShort } from '../domain/identity.js';
import type { RuleProposal } from '../store/types.js';

/**
 * WHO TYPED IT, wherever the proposal appears — and it is exported for that reason.
 *
 * The 2026 proposals reached Vishal and Rajan by email and Discord months before this screen
 * existed, so a commissioner entered them. "Entered by Tim, it is Matt's proposal" is two facts
 * and both are load-bearing: the second is the 2020-I-1 §2 veto, which belongs to the author and
 * not to the typist. The docket row shows it too — that is where most people read the thing.
 */
export function Transcribed({ p }: { p: RuleProposal }) {
  if (!p.enteredBy) return null;
  return (
    <p className="propentered">
      <span className="chip tiny commish">entered by {managerShort(p.enteredBy)}</span>
      {p.enteredVia && <span className="mut"> — {p.enteredVia}</span>}
      <span className="mut">
        {' '}It is {managerShort(p.gm)}’s proposal; he keeps the 2020-I-1 §2 veto over any wording
        change.
      </span>
    </p>
  );
}
